import { useRef } from "react";
import { useSite, useImages } from "@/context/SiteContent";
import { Tilt } from "./Tilt";

export const TikTokIcon = () => <svg fill="currentColor" viewBox="0 0 24 24"><path d="M14.5 3c.6 2.3 2 3.7 4.5 4v3.1c-1.7-.1-3.2-.6-4.4-1.5v6.1a5.8 5.8 0 1 1-5-5.7v3.2a2.7 2.7 0 1 0 1.8 2.5V3h3.1Z" /></svg>;
export const LinkedInIcon = () => <svg fill="currentColor" viewBox="0 0 24 24"><path d="M6.5 8.3H3.3V21h3.2V8.3ZM4.9 3A1.9 1.9 0 1 0 5 6.8 1.9 1.9 0 0 0 4.9 3ZM21 13.7c0-3.8-2-5.6-4.7-5.6-2.2 0-3.1 1.2-3.7 2v-1.7H9.4V21h3.2v-6.3c0-1.7.3-3.3 2.4-3.3s2.1 1.9 2.1 3.4V21H21v-7.3Z" /></svg>;

const credentials = [
  ["25+", "Years of Corporate Experience", "Experience across business development, partnerships, relationship management and commercial growth.", true],
  ["SP", "Strategic Partnership Leadership", "Previously served as a Strategic Partnership Director in the finance industry."],
  ["BD", "Business Development & Growth", "Experience identifying opportunities, building relationships and developing long-term partnerships."],
  ["RM", "Relationship Management", "Years of experience working in client-facing environments where trust and communication are critical."],
];
const principles = [
  ["01", "Practical over theoretical", "Lessons are built around situations people actually encounter at work."],
  ["02", "Growth through consistency", "The philosophy focuses on learning, practising, reflecting and improving over time."],
  ["03", "Career and life are connected", "The 5Ps connect professional development with relationships, lifestyle and financial resources."],
];

const TiltCard = () => {
  const card = useRef(null);
  const shine = useRef(null);
  const raf = useRef(null);
  const images = useImages();
  const move = (cx, cy) => {
    const rect = card.current.getBoundingClientRect();
    const x = (cx - rect.left) / rect.width, y = (cy - rect.top) / rect.height;
    if (raf.current) cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(() => {
      card.current.style.transform = `rotateX(${(0.5 - y) * 10}deg) rotateY(${(x - 0.5) * 14}deg) translateY(-3px)`;
      shine.current.style.transform = `translateX(${(x - 0.5) * 28}%) translateY(${(y - 0.5) * 8}%) translateZ(18px)`;
      shine.current.style.opacity = "0.85";
    });
  };
  const reset = () => {
    if (raf.current) cancelAnimationFrame(raf.current);
    card.current.style.transform = "rotateX(0deg) rotateY(0deg) translateY(0)";
    shine.current.style.transform = "translateX(-35%) translateZ(18px)";
    shine.current.style.opacity = "";
  };
  return (
    <div className="photo scott-photo scott-tilt-card" ref={card} data-testid="scott-tilt-card"
      onMouseMove={(e) => move(e.clientX, e.clientY)} onMouseLeave={reset}
      onTouchMove={(e) => { const t = e.touches[0]; if (t) move(t.clientX, t.clientY); }} onTouchEnd={reset}>
      <div className="scott-portrait-bg" />
      <div className="scott-portrait-rings" />
      <div className="scott-portrait-shine" ref={shine} />
      <img alt="Scott Tang" className="scott-portrait-img" src={images.scott} />
      <div className="scott-depth-tag">Corporate Experience</div>
      <div className="scott-floating-badge badge-one">25+ Years</div>
      <div className="scott-floating-badge badge-two">Strategic Partnerships</div>
    </div>
  );
};

export const Scott = () => {
  const { scott, links } = useSite();
  return (
  <section className="about-section scott-profile-section" id="scott" data-testid="scott-section">
    <div className="container">
      <div className="scott-profile-grid">
        <div className="scott-portrait-panel reveal">
          <TiltCard />
          <div className="scott-signoff">
            <span className="eyebrow">{scott.signoffName}</span>
            <strong>{scott.signoffTitle}</strong>
            <small>{scott.signoffSub}</small>
          </div>
        </div>
        <div className="scott-story reveal">
          <div className="eyebrow">{scott.eyebrow}</div>
          <h2>{scott.heading}</h2>
          <p className="lead">{scott.lead}</p>
          {scott.paragraphs.map((para, i) => <p key={i}>{para}</p>)}
          <div className="scott-credential-grid">
            {credentials.map(([mark, title, copy, isNumber]) => (
              <Tilt max={7} className="credential-card" key={title}>
                {isNumber ? <span className="credential-number">{mark}</span> : <span className="credential-icon">{mark}</span>}
                <strong>{title}</strong><small>{copy}</small>
              </Tilt>
            ))}
          </div>
          <div className="scott-principles">
            {principles.map(([n, t, p]) => <div key={n}><span>{n}</span><strong>{t}</strong><p>{p}</p></div>)}
          </div>
          <div className="socials">
            <a className="social" href={links.tiktok} rel="noopener noreferrer" target="_blank" data-testid="scott-tiktok-link"><TikTokIcon /> @campustocorporate1</a>
            <a className="social" href={links.linkedin} rel="noopener noreferrer" target="_blank" data-testid="scott-linkedin-link"><LinkedInIcon /> View Scott's LinkedIn</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
